import React, { FC, useMemo } from 'react';
import { LanguageType } from 'moduleBase/types/LanguageType';
import { useLocation } from 'react-router';
import urlAppendParam from '@collaborator/npm_modules/dist/helpers/url/urlAppendParam';

const LangsMenuItem: FC<LanguageType> = ({
  name,
  currentPageUrl,
  isActive,
}) => {
  const location = useLocation();
  const url = useMemo(() => {
    let urlForRedirect = window.location.pathname;
    if (window.location.search) {
      urlForRedirect += window.location.search;
    }

    return urlAppendParam(currentPageUrl, 'url', urlForRedirect);
  }, [location.pathname, location.search]);

  if (isActive) {
    return (
      <div className="dropdown-flat-submenu__item active">
        {name}
      </div>
    );
  }

  return (
    <a className="dropdown-flat-submenu__item" href={url}>
      {name}
    </a>
  );
};

export { LangsMenuItem };
